import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { FFContextProvider } from "@harnessio/ff-react-client-sdk";
import { withFeatureFlags } from "@harnessio/ff-react-client-sdk";
import InitialLoading from "./Components/common/InitialLoading";
import ReactGA4 from "react-ga4";
function MyComponent({ flags, loading }) {
  if (loading) {
    return <InitialLoading />;
  }
  return <App />;
}
const MyComponentWithFlags = withFeatureFlags(MyComponent);

const root = ReactDOM.createRoot(document.getElementById("root"));

const reactTarget = { name: "ReactClientSDK", identifier: "reactclientsdk" };
const sdkApiKey = process.env.REACT_APP_HARNESS_KEY;
const isLocalDevelopment = process.env.REACT_APP_ENV === "dev";

if (process.env.REACT_APP_ENV === "prod") {
  ReactGA4.initialize("G-W80E8QN28V");
}

const RootComponent = isLocalDevelopment ? (
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <FFContextProvider async apiKey={sdkApiKey} target={reactTarget}>
          <MyComponentWithFlags />
        </FFContextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
) : (
  // </React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <FFContextProvider async apiKey={sdkApiKey} target={reactTarget}>
        <MyComponentWithFlags />
      </FFContextProvider>
    </PersistGate>
  </Provider>

);
root.render(RootComponent);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
